module.exports = __webpack_public_path__ + "img/loan.91d996e0.svg";